export const leadConstant = {
  SET_LEAD_STATUSES: 'SET_LEAD_STATUSES',
  SET_AGENCY_MEMBERS: 'SET_AGENCY_MEMBERS',
  LOADING_LEAD_STATUSES: 'LOADING_LEAD_STATUSES',
  LOADING_AGENCY_MEMBERS: 'LOADING_AGENCY_MEMBERS',
};
